import Vue from 'vue';
import VueRouter from 'vue-router';

import VuetifyCal from './components/VuetifyCal.vue';
import Test from './components/Test.vue';
import AppointmentCal from './components/AppointmentCal';
Vue.use(VueRouter);

export default new VueRouter({
	routes: [
		{ path: '/admin/assignment/calendar/view/:assignmentId', component: VuetifyCal },
		{ path: '/admin/assignment/calendar/view/:assignmentId/test', component: Test },
		{ path: '/admin/appointment/calendar/view/:projectId', component: AppointmentCal },

		
	],
	mode: 'history'
})